import styles from "./style.module.css";

const Card = ({ title, value, icon: Icon, color }) => (
    <div className={styles.card}>
        <Icon size={40} color={color} className={styles.icon} />
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.value}>{value}</p>
    </div>
);
export default Card;
